import { useQueryClient } from "@tanstack/react-query";
import React, { Fragment, useEffect, useState } from "react";

import styled from "styled-components/macro";

import houseHoldDatabaseKeys from "HouseholdDatabase/API/keys";
import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";

import FnrButton3 from "UI/FnrButton3";
import FnrLoadingBricks from "UI/FnrLoadingBricks";
import { FnrPopoverWithScroll } from "UI/FnrPopover2";

import useUpdateSetting from "../useUpdateSetting";

import RemoveStatusInUse from "./RemoveStatusInUse";

export default function DeletionConfirmation({
  buttonRef,
  show,
  setShow,
  description,
  membershipStatusID,
  statusInUse,
}) {
  const { updateSetting, saving, error, setError } = useUpdateSetting();
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);

  async function handleDelete() {
    setIsLoading(true);
    let res = await updateSetting({
      setting: "membershipStatus",
      itemID: membershipStatusID,
      value: null,
      action: "delete",
    });

    if (res) {
      setShow(false);
      setIsLoading(false);
      // invalidate household database cache so that the status is removed immediately
      queryClient.invalidateQueries(houseHoldDatabaseKeys.all());
    }
  }

  const onShouldClose = (e) => {
    const eventIsFromDropdown = Array.from(e.target.classList).includes(
      "dropdown_option_wrapper"
    );
    if (eventIsFromDropdown || isLoading) return;

    setShow(false);
  };

  return (
    <FnrPopoverWithScroll
      buttonRef={buttonRef}
      show={show}
      scrollingElClassname=".fam-reg-admin-panel-content-wrapper"
      onShouldClose={onShouldClose}
    >
      {statusInUse ? (
        <RemoveStatusInUse
          status={description}
          setShow={setShow}
          membershipStatusID={membershipStatusID}
        />
      ) : (
        <Content>
          <p style={{ margin: 0 }}>
            Are you sure you want to delete {description}?
          </p>

          <ButtonWrapper>
            <FnrButton3 onClick={() => setShow(false)}>Cancel</FnrButton3>
            <FnrButton3 onClick={handleDelete} color="red" loading={isLoading}>
              Delete
            </FnrButton3>
          </ButtonWrapper>
        </Content>
      )}
    </FnrPopoverWithScroll>
  );
}

export const Content = styled.div`
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 18px;
  max-width: 300px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

const CloseWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  color: white;
  cursor: pointer;
  box-sizing: border-box;
  padding: 2px 7px;
  z-index: 100;

  > i {
    cursor: pointer;
  }
`;
